export default __webpack_public_path__ + "static/media/img.6da752d0.svg";